/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Auth_Gate_Action_UpvoteInputs */

const en_common_auth_gate_action_upvote = /** @type {(inputs: Common_Auth_Gate_Action_UpvoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`like products`)
};

const zh_common_auth_gate_action_upvote = /** @type {(inputs: Common_Auth_Gate_Action_UpvoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为你喜欢的产品点赞`)
};

/**
* | output |
* | --- |
* | "like products" |
*
* @param {Common_Auth_Gate_Action_UpvoteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_auth_gate_action_upvote = /** @type {((inputs?: Common_Auth_Gate_Action_UpvoteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Auth_Gate_Action_UpvoteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_auth_gate_action_upvote(inputs)
	return zh_common_auth_gate_action_upvote(inputs)
});
export { common_auth_gate_action_upvote as "common.auth.gate.action.upvote" }